<template>
	<!-- <div class="job-card-slim__container"> -->
    <a :href="`/opportunity/redirect/${payload['objectID']}`">
      <div class="job-card-slim">

        <!-- left -->
        <div class="job-card-slim__left">
          <div class="job-card-slim__logo-container">
            <img class="job-card-slim__logo" :src="$filters.analyseImage(payload['org-logo'], 'logosm', 'logoxl')" :alt="payload['org-name']" width="54" height="54" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
          </div>

          <!-- popup panel on logo hover -->
          <div class="job-card-slim__hover-panel">
            <div class="job-card-slim__hover-panel-header">
              <div class="job-card-slim__logo-container">
                <img class="job-card-slim__logo" :src="$filters.analyseImage(payload['org-logo'], 'logosm', 'logoxl')" :alt="payload['org-name']" width="54" height="54" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
              </div>
              <block-alert-button classes="job-card-slim__hover-panel-create-alert" :org_main_id="payload['org-main-id']" :org_name="payload['org-name']"></block-alert-button>
            </div>
            <div class="job-card-slim__hover-panel-body">
              <h4 v-if="payload['org-name']" class="job-card-slim__hover-panel-org-name"><a :href="`/organisation/redirect/${payload['org-main-id']}`" target="_blank">{{ payload['org-name'] }}</a></h4>
              <ul v-if="payload['option-esc-factor'] && payload['option-esc-factor'] != ''" class="job-card-slim__hover-panel-factors">
                <li v-for="factor in payload['option-esc-factor']" :key="factor">
                  {{ factor }}
                </li>
              </ul>
              <p v-if="payload['org-summary'] && payload['org-summary'] != ''" class="job-card-slim__hover-panel-org-summary">{{ payload['org-summary'] }}</p>
            </div>
            <div class="job-card-slim__hover-panel-footer">
              <div v-if="payload['listings-live-public'] && payload['listings-live-public'] != ''" class="job-card-slim__hover-panel-bottom-jobs">
                <a :href="searchLink">
                  {{ payload['listings-live-public'] }} <span>Jobs</span>
                </a>
              </div>
              <div v-if="payload['review-count'] && payload['review-count'] != ''" class="job-card-slim__hover-panel-bottom-reviews">
                {{ payload['review-count'] }} <span>Reviews</span>
              </div>
            </div>
          </div>
        </div>

        <!-- right -->
        <div class="job-card-slim__right">
          <div class="job-card-slim__right-top">
            <div class="job-card-slim__right-content">
              <h3 v-if="payload['job-title']" class="job-card-slim__title"><a :href="`/opportunity/redirect/${payload['objectID']}`" target="_blank">{{ payload['job-title'] }}</a></h3>
            </div>

            <div class="job-card-slim__right-actions">
              <block-action-bookmark-job :job_id="payload['objectID']"></block-action-bookmark-job>
            </div>
          </div>

          <div class="job-card-slim__right-bottom">
            <div class="job-card-slim__right-bottom-group-top">
              <p v-if="payload['org-name']" class="job-card-slim__org-name"><a :href="`/organisation/redirect/${payload['org-main-id']}`" target="_blank">{{ payload['org-name'] }}</a></p>

              <!-- location -->
              <p v-if="payload['location-txt']" class="job-card-slim__location">{{payload['location-txt']}}</p>
            </div>

            <div class="job-card-slim__right-bottom-group-bottom">

              <!-- salary -->
              <div class="job-card-slim__salary-group">
                <div class="job-card-slim__salary-icon-container">
                  <img class="job-card-slim__salary-icon" :src="`/images/icons/organisation/salary.svg?${$config.version}`" alt="Salary" loading="lazy">
                </div>

                <p v-if="payload['option-listing-type'] && payload['option-listing-type'].toLowerCase() === 'volunteer'" class="job-card-slim__salary-text">Volunteer role</p>
                <template v-else>
                  <p v-if="payload['salary-low'] !== null && payload['show-sal'] === false" class="job-card-slim__salary-text estimated">
                    <span>From ~ £{{ payload['salary-low'] }}</span>
                    <span>(Esc estimated)</span>
                  </p>
                  <p v-if="payload['salary-low'] !== null && payload['show-sal'] === true" class="job-card-slim__salary-text verified">
                    <span>From £{{ payload['salary-low'] }}</span>
                    <span>&#10004; Employer verified</span>
                  </p>
                  <p v-if="payload['salary-low'] === null" class="job-card-slim__salary-text">Please enquire</p>
                </template>
              </div>

              <!-- term -->
              <p v-if="payload['option-term'][0]" class="job-card-slim__listing-type"><span>{{payload['option-term'][0]}}</span></p>

              <!-- icons -->
              <div class="job-card-slim__right-bottom-icons">
                <div class="job-card-slim__right-bottom-icon-container">
                  <img src="/images/icons/shared/lady.svg" class="job-card-slim__right-bottom-icon" alt="" title="Lady"/>
                </div>

                <div class="job-card-slim__right-bottom-icon-container">
                  <img src="/images/icons/shared/artboard.svg" class="job-card-slim__right-bottom-icon" alt="" title="Art Board"/>
                </div>

                <div class="job-card-slim__right-bottom-icon-container">
                  <img src="/images/icons/shared/church.svg" class="job-card-slim__right-bottom-icon" alt="" title="Church"/>
                </div>

                <div class="job-card-slim__right-bottom-icon-container">
                  <img src="/images/icons/shared/top100.svg" class="job-card-slim__right-bottom-icon" alt="Escape Top 100" title="Escape Top 100"/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </a>
  <!-- </div> -->
</template>

<script>
import AuthMixins from '@/mixins/AuthMixins';

export default {
  mixins: [AuthMixins],

  props: {
    payload: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
    }
  },

  mounted() {
    // console.log('JobCardSmall:', this.payload);
  },

  computed: {
    searchLink() {
			var query_array = ["org-name="+this.payload['org-name']];
			var query = query_array.join("&");
			// Needs to be double encoded, don't know why!
			return '/search/jobs?q='+encodeURIComponent(encodeURIComponent(query));
		}
  }
}
</script>

